export enum TaskHighlights {
	All,
	Completed,
	NotCompleted,
	AddedMidSprint,
	CarryOver,
}
